<template>
  <div style="height:100%">
    <BaseContainer style="height:100%" class="one_table">
      <TableMain name="one table" ref="forecastSalesCopackingRef" :fields="fields" :title="table_title.title1"
        :show_query_container="false" :show_toolbar_container="true" :show_pagination_container="true"
        :show_date_picker="true" :show_toolbar="true" :show_filter="true" :date_picker_label="date_picker_label"
        :query_button_label="query_lable" @state_change="state_change" :show_toolbar_button="[1, 1, 0, 0, 0]"
        @tool_invoke="tool_invoke" @current_changed="current_changed" :isBusy="isBusy_table1" tableref="25a01fe44d12458c8b3f556a8db44cee">
        <template #toolbar>
          {{ $t("common.create_date") }}:
          <el-date-picker class="ml-2" size="small" style="width: 220px" v-model="date_range" type="daterange"
            align="right" unlink-panels range-separator="-" start-placeholder="" end-placeholder=""
            :picker-options="pickerOptions()">
          </el-date-picker>
          <el-tooltip content="刷新数据" placement="top" effect="light">
            <el-button type="info" plain @click="getCopackingData" style="width: 55px" class="ml-2 fa fa-refresh"
              size="mini"></el-button>
          </el-tooltip>
          <el-checkbox :label="$t('common.show_only_valid')" v-model="onlyValid" class="ml-4"
            @change="filterData()"></el-checkbox>
          <el-checkbox :label="$t('common.has_excuted')" v-model="onlyNoCopacking" class="ml-2"
            @change="filterData()"></el-checkbox>
        </template>
        <template #operation>
          <QueryButton :type="'success'" :iconClass="'iconfont icon-save'" :size="'mini'" @on_query="saveCopacking"
            :label="$t('common.save')" class="ml-2">
          </QueryButton>
        </template>
      </TableMain>
    </BaseContainer>
  </div>
</template>

<script>
// -- import * as _ from "lodash-es"
import QueryButton from "../components/base/QueryButton"
import * as OrderForecastCopackingController from "../../controllers/sd/OrderForecastCopackingController"
import BaseContainer from "../components/BaseContainer"
import TableMain from "../components/table/TableMain"
export default {
  name: "OrderForecastCopacking",
  components: {
    QueryButton,
    BaseContainer,
    TableMain,
  },
  data() {
    return {
      fileList: [],
      table_title: {
        title1: "table_copacking",
      },
      date_picker_label: "common.search",
      query_lable: this.$t("common.query"),
      fields: OrderForecastCopackingController.fields.default,
      hisDataList: [],
      date_range: "",
      isBusy_table1: false,
      onlyValid: true,
      onlyNoCopacking: false,
    }
  },
  created() {
    const end = new Date()
    const start = new Date()
    start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
    this.date_range = [start, end]
    this.getCopackingData()
  },
  methods: {
    pickerOptions() {
      return {
        shortcuts: [
          {
            text: "最近7天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近30天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit("pick", [start, end])
            },
          },
          {
            text: "最近90天",
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit("pick", [start, end])
            },
          },
        ],
      }
    },
    async getCopackingData() {
      this.isBusy_table1 = true
      let p = {}
      let _fromDate = "",
        _toDate = ""
      if (!_.isNull(this.date_range)) {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        // p["create_at"] = { ">=": _fromDate, "<=": _toDate };
        p["fromDate"] = _fromDate
        p["toDate"] = _toDate
      }
      let _result = await OrderForecastCopackingController.methods.getData(p)
      this.$refs.forecastSalesCopackingRef.SetData([])
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.hisDataList = _result[0]
        this.filterData()
      }
      this.isBusy_table1 = false
    },
    async resetIdsData(ids) {
      let p = {}
      let _fromDate = "",
        _toDate = ""
      if (!_.isNull(this.date_range)) {
        _fromDate = this.$date.format(this.date_range[0], "yyyy-MM-dd")
        _toDate = this.$date.format(this.date_range[1], "yyyy-MM-dd")
        _toDate = this.$date.format(
          this.$date.addDays(new Date(_toDate), 1),
          "yyyy-MM-dd"
        )
        // p["create_at"] = { ">=": _fromDate, "<=": _toDate };
        p["fromDate"] = _fromDate
        p["toDate"] = _toDate
      }
      let _result = await OrderForecastCopackingController.methods.getData(p)
      if (!_.isNull(_result) && _result && _result.length > 0) {
        this.hisDataList = _result[0]
        for (var i in ids) {
          let m = _.find(_result[0], { id: ids[i] })
          if (m) {
            this.$refs.forecastSalesCopackingRef.UpdateItems({ id: ids[i] }, m)
          }
        }

      }
    },
    //copacking
    async copackingMethod() {
      this.msgModal(this.$t("notify.is_create_order")).then(async (v) => {
        if (v) {
          let _gt_credit =
            await OrderForecastCopackingController.methods.pickAndInvoke([
              "070",
            ])
          if (_gt_credit) {
            if (_gt_credit.status != 0) {
              this.msgToasts(this.$t("notify.ax_error") + "：" + _gt_credit.message, "error")
              return
            }
          } else {
            this.msgToasts(this.$t("notify.ax_call_failed"), "error")
            return
          }

          let _result =
            await OrderForecastCopackingController.methods.copackingMethod()
          if (_result) {
            this.msgToasts(this.$t("notify.action_successfully"), "success")
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
          }
        }
      })
    },
    current_changed(old, current) { },
    tool_invoke(data) { },
    state_change(data, cb) {
      if (data.selected_items.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let _state = data.state == "valid" ? true : false
      let is_state_ok = true
      _.each(data.selected_items, (t) => {
        if (!_.isNull(t.ForecastLineNum) && t.ForecastLineNum != "" && !_state) {
          is_state_ok = false
        }
      })
      if (!is_state_ok) {
        this.msgToasts(this.$t("notify.has_forecast_can_not_be_valid"), "info")
        cb(false)
        return
      }
      let st = _.filter(data.selected_items, { is_valid: _state })
      if (st && st.length > 0) {
        this.msgToasts(this.$t("notify.has_valid_can_not_be_valid"), "info")
        cb(false)
        return
      }

      this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
        if (v) {
          let result = await OrderForecastCopackingController.methods.updateCopackingData(data.selected_items, _state)
          if (!_.isNull(result)) {
            _.each(data.selected_items, (t) => {
              t.is_valid = _state
            })
            this.msgToasts(this.$t("notify.action_successfully"), "success")
            cb(true, false)
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
          this.filterData()
        }
      })
    },
    //错误提示
    ErrorMsg(data) {
      if (_.isNull(data.NameAlias)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.invent") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.customerName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.customer") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.companyName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.company") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      if (_.isNull(data.ModelName)) {
        return ("<div>" + this.$t("common.customer") + ":<strong>" + data.AccountNum + "</strong>，" + this.$t("common.invent") + ":<strong>" + data.ItemId + "</strong>，<strong>" + this.$t("common.forecast_modal") + "</strong>" + this.$t("common.not_exist") + "</div>")
      }
      return ""
    },
    //保存
    async saveCopacking(cb) {
      let data = []
      data = this.$refs.forecastSalesCopackingRef.GetSelectedItems()
      if (data.length == 0) {
        this.msgToasts(this.$t("notify.not_data"), "info")
        cb(false)
        return
      }
      let is_valid_ok = true
      let is_copacking = true
      let ids = []
      _.each(data, (t) => {
        ids.push(t.id)
        if (!t.is_valid) {
          is_valid_ok = false
        }
        if (!_.isNull(t.ForecastLineNum) && t.ForecastLineNum != "") {
          is_copacking = false
        }
      })
      if (!is_valid_ok) {
        this.msgToasts(this.$t("notify.has_valid_can_not_create_order"), "info")
        cb(false)
        return
      }
      if (!is_copacking) {
        this.msgToasts(this.$t("notify.sales_order_is_created"), "info")
        cb(false)
        return
      }
      this.msgModal(this.$t("notify.is_continue")).then(async (v) => {
        if (v) {
          // //检查数据是否已被修改
          // let check = await OrderForecastCopackingController.methods.getData({
          //   id: { in: ids },
          // });
          // let state = true;
          // if (check) {
          //   _.each(check[0], (t) => {
          //     if (t.done) {
          //       this.msgToasts(
          //         "编号:" + t.id + " 已copacking！请刷新后重试！",
          //         "info"
          //       );
          //       cb(false);
          //       state = false;
          //       return;
          //     }
          //   });
          // }
          // if (!state) {
          //   return;
          // }

          const loading = this.$loading({
            lock: true,
            text: this.$t("notify.saveing"),
            spinner: "el-icon-loading",
            background: "rgba(0, 0, 0, 0.7)",
          })

          let json = []
          _.each(data, (t) => {
            json.push({ id: t.id })
          })

          let _result =
            await OrderForecastCopackingController.methods.copackingMethod(
              JSON.stringify(json)
            )
          if (_result && _result.length > 0) {
            if (_result[0][0].status == 0) {
              // this.$refs.forecastSalesCopackingRef.RemoveItems(data);
              await this.resetIdsData(ids)
              this.msgToasts(this.$t("notify.action_successfully"), "success")
              cb(true)
            } else {
              //this.msgToasts("copacking失败!", "error");
              let str = "<div><strong>" + this.$t("notify.create_failed_error") + ":</strong></div>"
              _.each(_result[0], (t) => {
                if (
                  _.isNull(t.NameAlias) ||
                  _.isNull(t.customerName) ||
                  _.isNull(t.companyName) ||
                  _.isNull(t.ModelName)
                ) {
                  //标红错误行
                  str += this.ErrorMsg(t)
                }
              })
              this.msgToasts(str, "error", 0, true, "notify550")
              cb(false)
            }
          } else {
            this.msgToasts(this.$t("notify.action_unsuccessfully"), "error")
            cb(false)
          }
          loading.close()
        } else {
          cb(false)
        }
      })
    },
    filterData() {
      let _lt = this.hisDataList
      if (!this.onlyValid && !this.onlyNoCopacking && _.isNull(this.date_range)) {
        this.$refs.forecastSalesCopackingRef.SetData(_lt)
      }
      else {
        if (this.onlyValid) {
          _lt = _.filter(_lt, { is_valid: true })
        }
        if (this.onlyNoCopacking) {
          _lt = _.filter(_lt, (t) => {
            if (!_.isNull(t.ForecastLineNum) && t.ForecastLineNum != "") {
              return t
            }
          })
        }
        else {
          _lt = _.filter(_lt, (t) => {
            if (_.isNull(t.ForecastLineNum) || t.ForecastLineNum == "") {
              console.log(t)
              return t
            }
          })
        }
        this.$refs.forecastSalesCopackingRef.SetData(_lt)
      }
    },
  },
}
</script>
<style>
.hb_table_so_class1 {
  width: 100%;
  font-size: 0.8rem;
  background-color: white;
  min-width: 210rem;
}
</style>
